(function ($, Drupal, once) {
  Drupal.behaviors.popupFocusFix = {
    attach: function (context) {

      once('popupFocusFix', 'body', context).forEach(function () {
        $(document).on('focusin', function () {
          const $popup = $('.survey-popup-wrapper:visible');
          if ($popup.length && !$popup.is(':focus') && !$popup.find(':focus').length) {
            $popup[0].focus();
          }
        });
      });
    }
  };
})(jQuery, Drupal, once);
